import { Helmet } from 'react-helmet-async';
import LeakedSearchTerms from 'src/sections/overview/dashboards/views/campaign-leaks/leaked-search-terms';

export default function CampaignLeaksLeakedSearchTerms() {
  return (
    <>
      <Helmet>
        <title>Campaign Leaks · Leaked Search Terms</title>
      </Helmet>

      <LeakedSearchTerms />
    </>
  );
}
